module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-54500295-1","head":false,"sampleRate":5,"siteSpeedSampleRate":10,"cookieDomain":"henrysbayhouse.co.uk"},
    }]
